var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquares(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 280,
    height: 350,
    viewBox: "0 0 280 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 350L210 350L210 280L280 280L280 350Z",
    fill: "#F78E31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M140 280L70 280L70 210L140 210L140 280Z",
    fill: "#F5BD89"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M210 210L140 210L140 140L210 140L210 210Z",
    fill: "#F7A85C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M280 140L210 140L210 70L280 70L280 140Z",
    fill: "#F5ECD7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M280 70L210 70L210 0L280 -6.11793e-06L280 70Z",
    fill: "#F48E32"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M210 70L140 70L140 0L210 -6.11793e-06L210 70Z",
    fill: "#F4BF88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M140 140L70 140L70 70L140 70L140 140Z",
    fill: "#F6D6B7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M70 70L0 70L-6.12126e-06 0L70 -6.11793e-06L70 70Z",
    fill: "#EF9130"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquares);
export default __webpack_public_path__ + "static/media/squares.7bdc1cb8f0da4245f74086de3753643a.svg";
export { ForwardRef as ReactComponent };